// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_194Zg","icon":"index_icon_ttozF","dropdownGray":"index_dropdownGray_3m1m4","dropdownDark":"index_dropdownDark_1PE7v","title":"index_title_2qInA"};